import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
  ListItem,
  ListItemAvatar,
  Typography,
} from '@mui/material';

import React, { forwardRef } from 'react';

import { Button } from '~/components/Button';
import {
  CHROME_EXTENSION_URL,
  FIREFOX_EXTENSION_URL,
  GMAIL_ADDON_URL,
  LINKEDIN_AUDIENCE_ARTICLE_URL,
  SLACK_APP_URL,
  ZAPIER_APP_URL,
} from '~/scripts/constants';

interface CardData {
  title: string;
  subtitle: string;
  image: string;
  href: string;
  cta: string;
}

export const IntegrationsCards = () => {
  const cards: CardData[] = [
    {
      title: 'Chrome',
      // category: 'Browser',
      subtitle: 'Go to any website and see their technologies and tech spend',
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/chrome-logo.png`,
      href: `${CHROME_EXTENSION_URL}?utm_source=nerdydata-integration-cards`,
      cta: 'Install',
    },
    {
      title: 'Firefox',
      // category: 'Browser',
      subtitle: 'Go to any website and see their technologies and tech spend',
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/firefox-logo.png`,
      href: FIREFOX_EXTENSION_URL,
      cta: 'Install',
    },
    {
      title: 'Gmail',
      // category: 'Email',
      subtitle: `See Tech Stacks while Emailing and speed up prospecting research in Gmail`,
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/gmail-logo.png`,
      href: GMAIL_ADDON_URL,
      cta: 'Add To Gmail',
    },
    {
      title: 'Slack',
      // category: 'Shortcut',
      subtitle: 'See tech stacks directly in Slack',
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/slack-logo.png`,
      href: SLACK_APP_URL,
      cta: 'Add To Slack',
    },
    {
      title: 'Linkedin Audience',
      // category: 'Advertising',
      subtitle: `Target Linkedin Ads based on Tech Usage`,
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/linkedin-logo.png`,
      href: LINKEDIN_AUDIENCE_ARTICLE_URL,
      cta: 'Learn More',
    },
    {
      title: 'API Access',
      // category: 'API',
      subtitle: 'Build your own integration using our API',
      href: '/api',
      cta: 'View Docs',
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/code.png`,
    },
    {
      title: 'MCP Server',
      // category: 'AI',
      subtitle: 'Use NerdyData in Claude Desktop, Cursor, Windsurf, and more',
      href: '/mcp',
      cta: 'Learn More',
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/code.png`,
    },
    {
      title: 'Zapier',
      // category: 'API',
      subtitle: 'Enrich Data with Domain and Tech Stacks',
      image: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/zapier-logo.png`,
      href: ZAPIER_APP_URL,
      cta: 'Add Zap',
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => {
        return (
          <Grid
            item
            key={index}
            xs={12}
            sm={12}
            md={4}
            lg={3}
            sx={{ display: 'grid' }}>
            <IntegrationCard {...card} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export const IntegrationCard = ({
  href,
  image,
  title,
  subtitle,
  cta,
}: CardData) => {
  const LinkComponent = forwardRef((props, ref) => (
    <Button
      {...props}
      sx={{ textTransform: 'unset' }}
      ref={ref as React.Ref<HTMLButtonElement>}
    />
  ));
  LinkComponent.displayName = 'LinkComponent';
  return (
    <Card variant="outlined" sx={{ display: 'flex' }}>
      <CardActionArea
        component={href.startsWith('/') ? LinkComponent : 'a'}
        LinkComponent={href.startsWith('/') ? LinkComponent : 'a'}
        target={href.startsWith('/') ? undefined : '_blank'}
        href={href}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
        }}>
        <ListItem alignItems="flex-start" sx={{ p: 0 }}>
          <CardContent>
            <ListItemAvatar sx={{ mb: 2 }}>
              <img width="40" src={image} alt={title} />
            </ListItemAvatar>
            <Typography variant="h5" gutterBottom color="primary">
              {title}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {subtitle}
            </Typography>
          </CardContent>
        </ListItem>
        <CardActions>
          <Typography variant="button" color="primary">
            {cta}
          </Typography>
        </CardActions>
      </CardActionArea>
    </Card>
  );
};
